import {
  ListItemComp,
  ListItemCompAction,
  ListItemCompContent,
  ListItemCompDescription,
  ListItemCompLeading,
  ListItemCompTitle,
  Switch,
} from '@mesh.ai/rabbit';
import { useToast } from 'components/hooks/useToast';

import { TOAST_STATUSES } from 'constants/ProjectConstants';

import { toggleNotificationChannel, toggleNotificationChannelForEmployees } from 'services/admin';

import { PaperWithShadow } from 'uiToolkitV1/Paper';

import { NOTIFICATION_EVENT_CHANNELS } from '../constants/NotificationSettingsConstants';
import type { ChannelDetails, ChannelEventDetails } from '../types';

type NotificationChannelsProps = {
  isEmployeeNotificationSettings?: boolean;
  refreshData: () => void;
  channelDetailsArray: ChannelDetails[];
  channelEventDetailsArray: ChannelEventDetails[];
};

export const NetchexNotificationChannels = ({
  isEmployeeNotificationSettings = false,
  channelDetailsArray,
  channelEventDetailsArray,
  refreshData,
}: NotificationChannelsProps) => {
  const toast = useToast();

  const channelOnToggle = async ({ uuid, channelType, enabled }) => {
    if (isEmployeeNotificationSettings) {
      try {
        await toggleNotificationChannelForEmployees({
          uuid,
          channelType,
          enabled,
          isEmployeeNotificationSettings,
        });

        refreshData();
        toast({
          title: 'Notification settings saved successfully!',
          status: TOAST_STATUSES.SUCCESS,
        });
      } catch (error) {
        console.error('Error in toggling the channel : ', error);
        toast({
          title: 'Error saving notification settings.',
          status: TOAST_STATUSES.ERROR,
        });
      }
    } else {
      try {
        await toggleNotificationChannel({ uuid, channelType, enabled });

        refreshData();
        toast({
          title: 'Notification settings saved successfully!',
          status: TOAST_STATUSES.SUCCESS,
        });
      } catch (error) {
        console.error('Error in toggling the channel : ', error);
        toast({
          title: 'Error saving notification settings.',
          status: TOAST_STATUSES.ERROR,
        });
      }
    }
  };

  return (
    <PaperWithShadow p={3}>
      <ListItemComp
        style={{
          height: '60px',
        }}
      >
        <ListItemCompLeading style={{ alignItems: 'flex-start', marginTop: '2px' }}>
          {NOTIFICATION_EVENT_CHANNELS.BELL.icon}
        </ListItemCompLeading>
        <ListItemCompContent>
          <ListItemCompTitle bold={false}>Enable Notifications</ListItemCompTitle>
          <ListItemCompDescription>Enable notifications across SMS, Push, and Email channels</ListItemCompDescription>
        </ListItemCompContent>
        <ListItemCompAction>
          <Switch
            checked={channelDetailsArray.some((cd) => cd.channelType === 'EMAIL' && cd.enabled)}
            onCheckedChange={(checked) =>
              channelOnToggle({
                uuid: NOTIFICATION_EVENT_CHANNELS.EMAIL.type,
                channelType: NOTIFICATION_EVENT_CHANNELS.EMAIL.type,
                enabled: checked,
              })
            }
          />
        </ListItemCompAction>
      </ListItemComp>
    </PaperWithShadow>
  );
};
